import {
  FilterQuery,
  NumericRangeFilter,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { Filter } from "../applied_filter/filter";

export const serializedTrueValue = "ano";
export const serializedFalseValue = "ne";

export const serializeFilterToPath = (
  basePath: string,
  availableFilters: Filter[],
  appliedFilter: FilterQuery
): string => {
  const segments = availableFilters
    .map((filter) => filter.serialize(appliedFilter))
    .filter(Boolean);

  if (segments.length === 0) {
    return basePath;
  }

  return basePath + "?" + segments.join("&");
};

export const deserializeFilterFromPath = (
  availableFilters: Filter[],
  categoryId: number,
  landingPageFilter: object,
  path: string
): FilterQuery => {
  const url = new URL("http://example.com" + path);
  const urlSearchParams = url.searchParams;

  const urlFilters = availableFilters.reduce(
    (acc, filter) => ({
      ...acc,
      ...filter.deserialize(urlSearchParams),
    }),
    { categoryId }
  );

  return Object.assign(urlFilters, landingPageFilter);
};

export const arrayProperty = <T>(
  filterUrlKey: string,
  values: T[]
): string | null =>
  values.length > 0
    ? `${filterUrlKey}=${values.slice().sort().join(",")}`
    : null;

export const rangeProperty = <T>(
  filterUrlKey: string,
  range: NumericRangeFilter
): string => `${filterUrlKey}=${range.gte}-${range.lte}`;

export const booleanProperty = (filterUrlKey: string, value: boolean): string =>
  `${filterUrlKey}=${value ? serializedTrueValue : serializedFalseValue}`;
